import { SORTING_DIR } from "@/common/models";
import { ITableConfig } from "@/components/table/table.model";
export const table_config: ITableConfig = {
  columns: [
    {
      name: "",
      key: "menu",
      spanMin: "4rem",
      spanMax: "4rem",
      sortable: false,
      filterable: false,
    },
    {
      name: "Event type",
      key: "eventType",
      spanMin: "12rem",
      spanMax: "15rem",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      jsPath: "data.events[].subType",
    },
    {
      name: "Exposed by",
      key: "exposedBy",
      spanMin: "14rem",
      spanMax: "1fr",
      sortable: false,
      filterable: false,
      jsPath: "data.events[].relatedEntities.exposedBy.entity.email",
    },
    {
      name: "Content",
      key: "items",
      spanMin: "16rem",
      spanMax: "1fr",
      sortable: false,
      filterable: false,
      jsPath: "data.events[].items[*].name",
    },
    {
      name: "Exposed to",
      key: "exposedTo",
      spanMin: "20rem",
      spanMax: "1fr",
      sortable: false,
      filterable: false,
      jsPath: "data.events[].relatedEntities.exposedTo[*].entity.email",
    },
    {
      name: "Date",
      key: "date",
      spanMin: "12rem",
      spanMax: "12rem",
      sortable: false,
      filterable: false,
      jsPath: "data.events[].date",
    },
    {
      name: "Application",
      key: "source",
      spanMin: "6rem",
      spanMax: "6rem",
      sortable: false,
      filterable: false,
      jsPath: "data.events[].sourceApplication",
    },
    {
      name: "Risk",
      key: "severity",
      spanMin: "6rem",
      spanMax: "6rem",
      sortable: false,
      filterable: false,
      jsPath: "data.events[].severityLevel",
    },
    {
      name: "Information Type",
      key: "information_type",
      spanMin: "14rem",
      spanMax: "1fr",
      sortable: false,
      filterable: false,
      jsPath: "data.events[].items[*].labels.infoLabel.name",
      csvOnly: true,
    },
    {
      name: "Handled",
      key: "handled",
      spanMin: "5rem",
      spanMax: "5rem",
      sortable: false,
      filterable: false,
      jsPath: "data.events[].mark",
    },
    {
      name: "Justification Request",
      key: "justification",
      spanMin: "14rem",
      spanMax: "1fr",
      sortable: false,
      filterable: false,
      jsPath: "data.events[].justification.status",
      csvOnly: true,
    },
    {
      name: "",
      key: "details",
      spanMin: "3rem",
      spanMax: "3rem",
      sortable: false,
      filterable: false,
    },
  ],
};
